import { useEffect } from "react";
import { launchChain } from "../../../api/launchpad";
import { verifySavedLaunches } from "../../../wallet/launchpad-transactions";
import { useLaunchWallet } from "./use-launch-wallet";

export function useLaunchVerification() {
  const wallet = useLaunchWallet("launch-verification");
  const { account, chainId } = wallet.snapshot;
  useEffect(() => {
    if (!account || chainId !== launchChain || import.meta.env.VITE_APP_MODE === "DEMO") return;
    let active = true;
    let timer: ReturnType<typeof setTimeout>;
    const check = async () => {
      try { await verifySavedLaunches(account, () => active); }
      catch { /* Keep unresolved evidence and retry later; never infer failure. */ }
      if (active) timer = setTimeout(() => { check().catch(() => {}); }, 5000);
    };
    check().catch(() => {});
    return () => { active = false; clearTimeout(timer); };
  }, [account, chainId, wallet.identity, wallet.revision]);
}
